import { Box, ConfirmDialog, FlexColumn } from "designSystem/index";
import { observer } from "mobx-react-lite";
import { FunctionComponent, default as React, useEffect, useRef } from "react";
import { useResizeObserver } from "designSystem/hooks";
import LBHeader from "./LBHeader";
import LBInfoPanel from "./LBInfoPanel";
import LBThumbnail from "./LBThumbnail";
import LBTurntableImageBox from "./LBTurntableImageBox";
import { useLightboxStore } from "./LightboxStore";

const PrivateLightbox: FunctionComponent<{}> = observer(function PrivateLightbox() {
	const {
		discardChanges, 
		handleKeyDown,
		imageBackgroundColor,
		lightBoxCloseConfirm,
		numImages,
		onCancelDiscardChanges, 
		openInfoPanel,
		setImageContainerDimensions,
		showInfoPanelCloseConfirm,
	} = useLightboxStore();

	const ref = useRef(null);

	const turnTableImageBoxContainerRef = useResizeObserver<HTMLDivElement>({
		onResize: ({ width, height }) => setImageContainerDimensions(width, height),
	}).ref;

	useEffect(() => {
		ref.current.focus();
	}, []);

	return (
		<FlexColumn
			onKeyDown={handleKeyDown}
			ref={ref}
			tabIndex={0}
		>
			<LBHeader />
			<Box
				display="flex"
				growNoOverflow
			>
				<ConfirmDialog
					category="error"
					confirmRes={lightBoxCloseConfirm ? "Leave" : "Close"}
					messageRes="ChangeWillNotBeSaved"
					onCancel={onCancelDiscardChanges}
					onConfirm={discardChanges}
					open={showInfoPanelCloseConfirm}
					titleRes={lightBoxCloseConfirm ? "LeaveWithoutSaving" : "CloseWithoutSavingTitle"}
				/>
				<Box
					centerContent
					growNoOverflow
					ref={turnTableImageBoxContainerRef}
					sx={{
						background: imageBackgroundColor,
						position: "relative",
						width: "100%",
						height: "100%",
					}}
				>
					<LBTurntableImageBox />
				</Box>
				{openInfoPanel &&
					<LBInfoPanel />
				}
			</Box>
			{numImages > 1 &&
				<LBThumbnail />
			}
		</FlexColumn>
	);
});

export default PrivateLightbox;
